import { Dispatch, SetStateAction } from 'react'
import { API_ERROR_MESSAGE, OTP_ERROR_MESSAGE } from '../../utils/Constants'
import { API_CALL_TYPE, getAPIUrl } from '../API'
import { ProductIds } from '../apiConstants'
import { makeApiCall } from '../APIService'

export interface ValidateOtpAndGetReportIdProps {
  identityNumber: string
  OTPValue: string
  hfAgentID: string
  hfSubscriberID: number
  reportTypeId: number
  setShowProgress: (value: boolean) => void
  setShowOTPFields: (value: boolean) => void
  setCreditReportId: Dispatch<
    SetStateAction<{ data: { reportId: string } } | undefined>
  >
  setShowDownloadReport: (value: boolean) => void
  setOTPValue: (value: string) => void
  setIsError: (value: boolean) => void
  setErrorMessage: (value: string) => void
  reference: string
  handleClick: () => void
  purpose: string
  downloadReport: (reportId?: string) => void
}

export const validateOtpAndGetReportId = async (
  props: ValidateOtpAndGetReportIdProps,
): Promise<void> => {
  const {
    identityNumber,
    OTPValue,
    hfAgentID,
    hfSubscriberID,
    setShowProgress,
    setIsError,
    setErrorMessage,
    setOTPValue,
    setShowDownloadReport,
    setCreditReportId,
    setShowOTPFields,
    reportTypeId,
    purpose,
    reference,
    handleClick,
    downloadReport,
  } = props
  const API_URL: string = getAPIUrl() + '/CreditEnquiry/load-reportbyid'
  const body: {
    identityNumber: string
    otpForValidation: string
    customerId: string
    subscriberId: number
    productId: number
    reportType: number
    reference: string
    purpose: string
    individualConsent: boolean
    purposeConsent: boolean
  } = {
    identityNumber,
    otpForValidation: OTPValue,
    customerId: hfAgentID,
    subscriberId: hfSubscriberID,
    productId: ProductIds.CreditEnquiryReport.productId,
    reportType: reportTypeId,
    reference,
    purpose,
    individualConsent: true,
    purposeConsent: true,
  }
  setShowProgress(true)
  makeApiCall(
    API_CALL_TYPE.POST_CALL,
    API_URL,
    (response) => {
      // setShowOTPFields(false)
      setShowProgress(false)
      downloadReport(response.data.reportId)
      setCreditReportId(response)
      setShowDownloadReport(true)
      setOTPValue('')
      setIsError(false)
      setErrorMessage('')
    },
    (error) => {
      setShowProgress(false)
      setIsError(true)
      setErrorMessage(error?.response?.data?.message || API_ERROR_MESSAGE)
    },
    body,
    {
      Authorization: 'Bearer ' + sessionStorage.getItem('jwt'),
    },
    null,
    false,
  )
}
